<!-- @format -->

@if (timedToPeriods(); as timedToPeriods) {
  <sis-study-notification-box *transloco="let t" [type]="'none'">
    <div class="multi-period-info">
      @if (currentPeriodIndexText(); as periodIndex) {
        <div class="multi-period-index-text" aria-hidden="true">{{ periodIndex }}</div>
      }
      {{ t("TIMELINE.TIMED_MULTIPLE_PERIODS", { periods: timedToPeriods }) }}
    </div>
  </sis-study-notification-box>
}
